/* Trade Bait NYC — cart interaction safety patch */
(function(){'use strict';
  function resetCartScroll(){
    var d=document.getElementById('sidebar-cart');
    if(!d) return;
    var main=d.querySelector('.Drawer__Main');
    var content=d.querySelector('.Drawer__Content');
    if(main) main.scrollLeft=0;
    if(content) content.scrollLeft=0;
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',resetCartScroll);
  else resetCartScroll();
  window.addEventListener('orientationchange',function(){setTimeout(resetCartScroll,100);setTimeout(resetCartScroll,400)},{passive:true});
})();